var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "InPlayerVideoOverlay",
    [
      _c(
        "OverlayContent",
        [
          _c("TitleMessage", { attrs: { slot: "title" }, slot: "title" }),
          _vm._v(" "),
          _c(
            "OverlayButton",
            {
              attrs: {
                slot: "content",
                tracker: _vm.getAnalyticPayload(function(e) {
                  return e.player["overlay-age-pin-gate"].click.action
                }, _vm.video.id)
              },
              on: {
                click: function($event) {
                  return _vm.performAction({
                    fn: _vm.openPinModal,
                    tracker: {
                      label: "enter-pin"
                    }
                  })
                }
              },
              slot: "content"
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("enter-pin")) + "\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }